export default __webpack_public_path__ + "static/media/woman-3.7efc1300.png";